<div class="min-h-full pb-8">

<div class="flex justify-between items-center mb-2">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Cadastro de Clientes</h1>
    </div>
  </div>

<div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    <p-tabs value="0" (valueChange)="activeTab = '' + $event">
      <p-tablist>
        <div class="flex justify-between w-full">
          <div class="flex">
            <p-tab value="0"><i class="pi pi-users"></i>Ínicio</p-tab>
            <p-tab value="1"><i class="pi pi-address-book"></i>Adicionais</p-tab>
            <p-tab value="3"><i class="pi pi-user-plus"></i>Dependentes</p-tab>
            <p-tab value="4"><i class="pi pi-cart-plus"></i>Novo Pedido</p-tab>
          </div>
          <div class="flex items-center ml-4">
          <p-checkbox 
            formControlName="active"
            binary="true"
            inputId="cbActive">
          </p-checkbox>
          <label for="cbActive" class="ml-2">Ativo</label>
        </div>
        </div>
          
      </p-tablist>
      <p-tabpanels>
      <p-tabpanel value="0">  
        <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
          <div class="col-span-3">
            <label class="block mb-1 font-medium">Nome Completo / Razão Social <span class="text-red-500">*</span></label>
            <div class="flex flex-col">
              <input
                pInputText
                formControlName="fullName"
                placeholder="Digite o nome"
                class="w-full"
              />
              <small class="text-red-500" *ngIf="isFieldInvalid('fullName')">Nome é obrigatório</small>
            </div>
            
          </div>

          <div>
            <label class="block mb-1 font-medium">Cpf <span class="text-red-500">*</span></label>
            <div class="flex flex-col">
              <p-inputmask mask="999.999.999-99" formControlName="cpf" placeholder="Digite o Cpf" class="w-full" />
              <small class="text-red-500" *ngIf="isFieldInvalid('cpf')">Cpf é obrigatório</small>
            </div>
          </div>


          <div>
            <label class="block mb-1 font-medium">Nascimento / Abertura </label>
            <p-datepicker formControlName="birthDay" />

          </div>
        </div>

        <div class="grid mt-4 grid-cols-1 md:grid-cols-5 gap-6">
          <div>
            <label class="block mb-1 font-medium">Cep</label>
            <p-inputmask
              mask="99999-999"
              formControlName="cep"
              class="w-full">
            </p-inputmask>
          </div>

          <div class="md:col-span-2">
            <label class="block mb-1 font-medium">Endereço</label>
            <input
              pInputText
              formControlName="address"
              placeholder="Digite o endereço"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Número</label>
            <input
              pInputText
              formControlName="addressNumber"
              placeholder="Digite o numero"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Complemento</label>
            <input
              pInputText
              formControlName="addressComplement"
              placeholder="Digite o complemento"
              class="w-full"
            />
          </div>

        </div>

        <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
          <div class="md:col-span-2">
            <label class="block mb-1 font-medium">Bairro</label>
            <input
              pInputText
              optionLabel="description"
              formControlName="district"
              placeholder="Digite o bairro"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Unidade Federativa</label>
            <p-select
              formControlName="state"
              [options]="states"
              optionLabel="description"
              optionValue="acronym"
              placeholder="Selecione o estado"
              class="w-full"
              [filter]="true"
              (onChange)="getCities($event)"
            ></p-select>
          </div>

          <div>
            <label class="block mb-1 font-medium">Cidade</label>
            <p-select
              formControlName="city"
              optionLabel="description"
              optionValue="description"
              [options]="cities"
              [filter]="true"
              placeholder="Selecione a cidade"
              class="w-full"
            ></p-select>
          </div>
        </div>

        <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <label class="block mb-1 font-medium">Telefone Fixo</label>
            <p-inputmask
              mask="(99) 9999-9999"
              formControlName="homePhone"
              class="w-full">
            </p-inputmask>
          </div>

          <div>
            <label class="block mb-1 font-medium">Celular</label>
            <p-inputmask
              mask="(99) 9999-9999"
              formControlName="phone"
              class="w-full">
            </p-inputmask>
          </div>

          <div>
            <label class="block mb-1 font-medium">WhatsApp </label>
            
            <div class="flex flex-col">
              <p-inputmask
                mask="(99) 99999-9999"
                formControlName="whatsApp"
                class="w-full">
              </p-inputmask>
            </div>
            
          </div>

          <div>
            <label class="block mb-1 font-medium">Email</label>
            <input
              pInputText
              formControlName="email"
              class="w-full"
            />
          </div>
        </div>

      </p-tabpanel>
      <p-tabpanel value="1">  
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div class="col-span-2">
            <label class="block mb-1 font-medium">Apelido / Nome fantasia</label>
            <input
              pInputText
              formControlName="nickName"
              placeholder="Digite o apelido"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Dia de Vencimento</label>
            <input
              pInputText
              formControlName="cpf"
              class="w-full"
            />
          </div>
        </div>

        <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <label class="block mb-1 font-medium">Limite de Crédito </label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              formControlName="creditLimit"
              [inputStyle]="{ width: '100%' }"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Saldo de Crédito </label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              readonly
              [inputStyle]="{ width: '100%' }"
              class="w-full"
            />
          </div>

          <div class="md:flex md:justify-between">
            <div>
                <label class="block mb-1 font-medium">Inadimplente</label>
                
                <div class="flex items-center">
                  <p-radiobutton [value]="'Liberar'" formControlName="situation" />
                  <label for="ingredient1" class="ml-2">Liberar</label>
              </div>

              <div class="flex items-center">
                  <p-radiobutton [value]="'Bloquear'" formControlName="situation" />
                  <label for="ingredient2" class="ml-2">Bloquear</label>
              </div>
            </div>
          </div>


            <div>
              <div>
              <p-checkbox
                formControlName="usePriceTable"
                binary="true">
              </p-checkbox>
                <label for="usePriceTableCheckBox" class="ml-2">Utilizar tabela de preços</label>
              </div>
               
              <div>
                <p-radioButton
                formControlName="selectedPrice"
                [value]="'money'"
                label="À vista">
              </p-radioButton>
              <label for="usePriceTableCheckBox" class="ml-2">À vista</label>
              </div>

              <div>
                <p-radioButton
                formControlName="selectedPrice"
                [value]="'installment'"
                label="Parcelado">
              </p-radioButton>
              <label for="usePriceTableCheckBox" class="ml-2">Parcelado</label>
              </div>
              

              <div>
                <p-radioButton
                formControlName="selectedPrice"
                [value]="'wholesale'"
                label="Atacado">
              </p-radioButton>
              <label for="usePriceTableCheckBox" class="ml-2">Atacado</label>

              </div>
              
            </div>

          <!-- <div>
            <label class="block mb-1 font-medium">Cashback </label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              [inputStyle]="{ width: '100%' }"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Saldo de Cashback </label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              readonly
              mode="currency"
              [inputStyle]="{ width: '100%' }"
              class="w-full"
            />
          </div> -->

        </div>

        <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
          
          <div class="md:col-span-4">
            <label class="block mb-1 font-medium">Observações</label>
            <textarea class="w-full" rows="5" pTextarea formControlName="observations"></textarea>
          </div>
        </div>
      </p-tabpanel>

      <p-tabpanel value="3">
        <div class="space-y-4">
          <div class="flex justify-between items-center">
            <h3 class="text-lg font-semibold text-gray-800">Dependentes</h3>
            <button type="button" (click)="addDependent()" class="flex items-center gap-2 bg-[#fe6a00] text-white px-4 py-2 rounded hover:bg-[#e65c00] text-sm font-medium cursor-pointer">
              <i class="pi pi-plus"></i> Adicionar dependente
            </button>
          </div>

          <div class="py-4" *ngIf="dependentsArray.length; else noDependents">
            <div class="bg-white shadow rounded md:max-h-50 lg:max-h-50 overflow-y-auto overflow-x-auto border border-gray-200">
              <table class="min-w-full text-sm table-fixed">
                <thead class="bg-gray-100 sticky top-0 z-10 border-b border-gray-200">
                  <tr>
                    <th class="text-left px-4 py-3 font-medium text-gray-700" style="width: 42%">Nome completo</th>
                    <th class="text-left px-4 py-3 font-medium text-gray-700" style="width: 22%">CPF</th>
                    <th class="text-left px-4 py-3 font-medium text-gray-700" style="width: 22%">Telefone</th>
                    <th class="text-center px-4 py-3 font-medium text-gray-700" style="width: 80px">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container formArrayName="dependents">
                    <tr *ngFor="let item of dependentsArray.controls; let i = index" [formGroupName]="i" class="border-b border-gray-100 last:border-b-0 hover:bg-gray-50/50 transition-colors">
                      <td class="px-4 py-3 align-middle">
                        <div class="w-full min-w-0">
                          <input
                            pInputText
                            formControlName="fullName"
                            placeholder="Nome completo"
                            class="w-full"
                          />
                        </div>
                      </td>
                      <td class="px-4 py-3 align-middle">
                        <div class="w-full min-w-0">
                          <p-inputmask mask="999.999.999-99" formControlName="cpf" placeholder="000.000.000-00" class="w-full" />
                        </div>
                      </td>
                      <td class="px-4 py-3 align-middle">
                        <div class="w-full min-w-0">
                          <p-inputmask mask="(99) 99999-9999" formControlName="phone" placeholder="(00) 00000-0000" class="w-full" />
                        </div>
                      </td>
                      <td class="px-4 py-3 align-middle text-center">
                        <button type="button" (click)="removeDependent(i)" class="inline-flex items-center justify-center w-9 h-9 text-red-600 hover:text-red-700 hover:bg-red-50 rounded transition-colors cursor-pointer" title="Remover dependente">
                          <i class="pi pi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <ng-template #noDependents>
            <div class="border border-gray-200 border-dashed rounded-lg bg-gray-50/50 py-12 text-center">
              <i class="pi pi-users text-4xl text-gray-300 mb-2 block"></i>
              <p class="text-gray-500">Nenhum dependente cadastrado.</p>
              <p class="text-gray-400 text-sm mt-1">Clique em "Adicionar dependente" para incluir.</p>
            </div>
          </ng-template>
        </div>
      </p-tabpanel>

      <p-tabpanel value="4">
        <app-create-order [tabActive]="activeTab === '4'" (onItemAdded)="onSaleSelected($event)" />
      </p-tabpanel>
    </p-tabpanels>
</p-tabs>

 <!-- Botões -->
    <div class="flex justify-end gap-3">
      <button (click)="goBack()" type="button" class="border px-2 border-orange-500 cursor-pointer rounded">Cancelar</button>
      <button
        type="submit"
        class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white"
      >
        {{ isEditMode ? 'Salvar' : 'Cadastrar' }}
      </button>
    </div>
  </form>
</div>

</div>
<p-toast />
